// extracted by mini-css-extract-plugin
module.exports = {"root":"_3YpkE","visible":"_2VIvz","content":"_1qBwv","text":"ii-Or","buttons":"_2d7SS","button":"_3-gdi","link":"_7nc8j","emphasis":"_1i3Zi"};